<app-loading-container mode="{{brandName}}">
	<div id="main" role="main">
		<div id="topper">
			<a href="" (click)="skipToContent($event)" id="skip-main" class="skip-main">{{ _bundle ? _bundle['button.skip'] : '' }}</a>
		</div>
		<router-outlet></router-outlet>
		<div id="footer-container" class="rcl-container no-print">
			<rcl-footer [text]="'© ' + year + ' ' + (_bundle && _bundle['footer.brand'] ? _bundle['footer.brand'] : footerBrandName)">
				<a [href]="urlService.aboutUs() " target="_blank" rel="noopener">{{ _bundle ? _bundle['button.about.us'] : 'About us' }}</a>
				<a [href]=" urlService.contactUs() " target="_blank" rel="noopener">{{ _bundle ? _bundle['footer.link.contact.us'] : 'Contact us' }}</a>
				<a *ngIf="!bookingService.isCelebrity" [href]=" urlService.privacyPolicy() " target="_blank" rel="noopener">{{
					_bundle ? _bundle['button.privacy'] : 'Privacy'
				}}</a>
				<a [href]=" urlService.legal() " (click)="openLegalModalDialog($event)">{{ _bundle ? _bundle['button.legal'] : 'Legal' }}</a>
				<a [href]=" urlService.siteMap() " target="_blank" rel="noopener">{{ _bundle ? _bundle['button.site.map'] : 'Site map' }}</a>
			</rcl-footer>
		</div>
	</div>
	<app-prompts [bundle]="_bundle"></app-prompts>
</app-loading-container>
